export const sortMethods = {
  timeReverse: function(a, b){
    return a.createdAt < b.createdAt ? 1 : -1;
  }
}
